<template>
  <el-tooltip
    :disabled="isChatReady"
    content="Please wait while the chat loads">
    <a
      :class="{
        'chat-icon-disabled': !isChatReady,
        'active': NoResultsTour.currentStep === 1
      }"
      class="chat-icon no-results-tour-1"
      @click="toggleChatWidget"/>
  </el-tooltip>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ChatButton',
  data() {
    return {
      isChatReady: false
    }
  },
  computed: {
    ...mapGetters('accounts', [
      'accountInfoLoaded',
      'email',
      'name',
      'firstName',
      'lastName',
      'phone'
    ]),
    ...mapState('tours', ['NoResultsTour'])
  },
  watch: {
    accountInfoLoaded() {
      this.syncChatUserIfReady()
    }
  },
  mounted() {
    const tryMarkReady = () => {
      const el = document.querySelector('[id*="zohodesk"], [class*="zohodesk"]')
      if (el) {
        this.isChatReady = true
        this.syncChatUserIfReady()
        return true
      }
      return false
    }
    if (tryMarkReady()) return

    const mutationObserver = new MutationObserver(() => {
      if (tryMarkReady()) mutationObserver.disconnect()
    })
    mutationObserver.observe(document.body, { childList: true, subtree: true })
  },
  methods: {
    toggleChatWidget() {
      this.noResultsTourEnd()
      this.$chat.toggle()
    },
    noResultsTourEnd() {
      const NoResultsTour = this.$tours.NoResultsTour

      if (
        NoResultsTour &&
        NoResultsTour.isRunning &&
        NoResultsTour.currentStep === 1
      ) {
        NoResultsTour.stop()
      }
    },
    syncChatUserIfReady() {
      if (!this.isChatReady || !this.accountInfoLoaded) return
      this.setUserInChat()
    },
    setUserInChat() {
      this.$chat.setUser({
        name: this.name,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-icon-disabled {
  display: none;
}
</style>
